import { Injectable } from '@angular/core';
import { PaginatedPricingStore, LoadType } from '../shared/paginated-pricing.store';
import { PricingOrder, PricingSort } from '../shared/pricing.types';

@Injectable({ providedIn: 'root' })
export class ReviewsService extends PaginatedPricingStore {
  override readonly type: LoadType = 1;
  protected override readonly errorMessage = 'Failed to load reviews';
  protected override readonly defaultSort: PricingSort | null = 'id';
  protected override readonly defaultOrder: PricingOrder | null = 'ASC';

  constructor() {
    super();
    // Override signal defaults for reviews
    this.sort.set(this.defaultSort);
    this.order.set(this.defaultOrder);
  }
}
